import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { Col, Container, Form, Label, Row } from "reactstrap";
import BreadCrumb from "../Common/BreadCrumb";
import { ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import CommonButton from "../Utils/CommonButton";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "../Utils/Loader";
import { customerIdData } from "../Customers/constants/constantFunctionsView";
import UserDetails from "./UserDetail";
import { validationSchema, validationSchemaForUser } from "./Constant/valiadationshema";
import { formatPhoneNumberIntl } from "react-phone-number-input";
import 'react-phone-number-input/style.css';
import { createUser } from "../../slices/UserManagement/CreateUser/thunk";
import { updateUser } from "../../slices/UserManagement/UpdateUser/thunk";
import { getUserByName } from "../../slices/UserManagement/GetUserByName/thunk";
import { LabelText } from "../Utils/Input";
import { documentJson, documentUpdateJson, handleChangePassword } from "./Constant/JsonConstant";
import { viewDoc } from "../../slices/customer/documentview/thunk";
import { documentUpdateFile } from "../../slices/customer/documentupdatefile/thunk";
import { partnerUploadDocument } from "../../slices/PartnerMangement/PartnerDocumentUpload/thunk";
import { resetDocumentViewState } from "../../slices/customer/documentview/reducer";

export default function CreateEditUser({ isEditMode, userInformation, onCancel, onSuccess ,isUserPath,customRoles,isGroupedOptions,domain,operatorUser,operatorId}) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const location = useLocation();
    const changePassword = location?.state?.changePassword || false;
    const [loading, setLoading] = useState()
    const [logoFile, setLogoFile] = useState(null);
    const [imageOn, setImageOn] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [isStatus, setIsStatus] = useState(false);
    const toggleModal = () => setModalOpen(!modalOpen);
    const [editData, setEditData] = useState(null);
    const [fileSelected, setFileSelected] = useState(false);
    const [profileData, setProfileData] = useState(false)
    const isEdit = isEditMode
    const userId = customerIdData()

    // Add state to track if form submission is in progress
    const [isSubmitting, setIsSubmitting] = useState(false);

    // Default initial values
    const defaultInitialValues = {
        firstname: "",
        lastname: "",
        username: "",
        userrole: "",
        phone: "",
        email: "",
        status: "",
        newPassword: "",
        confirmNewPassword: "",
        isSSOUser: false,
    }

    // Get initial values based on edit mode and user data
    const getInitialValues = () => {
        if (isEdit && userInformation) {
            return {
                firstname: userInformation?.profile?.firstName || "",
                lastname: userInformation?.profile?.lastName || "",
                username: userInformation?.userDetails?.userName || "",
                userrole: { value: userInformation?.role, label: userInformation?.role },
                phone: userInformation?.userDetails?.dialCode + userInformation?.userDetails?.phone || "",
                email: userInformation?.email || "",
                status: userInformation?.status || "",
                newPassword: "",
                confirmNewPassword: "",
                isSSOUser: userInformation?.isSSOUser || false,
            };
        }
        return defaultInitialValues;
    };

    // Enhanced cancel function that resets form and calls parent's onCancel
    const handleCancel = () => {
        if (onCancel) {
            // Reset any local state before calling onCancel
            setLogoFile(null);
            setImageOn(false);
            setFileSelected(false);
            setProfileData(false);
            setIsSubmitting(false);
            onCancel();
        }
    };

    const operatorConfiguration = useSelector(
        (state) =>
            state?.GetOperatorSpecificConfiguration?.OperatorSpecificConfiguration
    );

    const idps = operatorConfiguration?.configurations?.identityManagement?.value?.IdentityProvider?.value;

    const user = userInformation

    useEffect(() => {
        if (isEdit && editData && editData?.userDetails?.userName) {
            let partnerOrCustomer = "User"
            dispatch(viewDoc(setLoading, userId, "logo", partnerOrCustomer, setProfileData));
        }
    }, [dispatch, isEdit, editData])

    let base64ImageData = []
    let profile = useSelector((state) => state.ViewDocument.documentView)
    const [update, setUpdate] = useState(!!profile);
    base64ImageData = profile?.filePath
    let documentName = profile?.documentName

    useEffect(() => {
        if (isEdit && base64ImageData) {
            setLogoFile(base64ImageData);
        }
        if (!profileData && isEdit) {
            setLogoFile(null)
        }
    }, [isEdit, base64ImageData, profileData]);

    // Enhanced submit handler with success/error handling
    const handleFormSubmit = async (values) => {
        if (isSubmitting) return; // Prevent double submission
        
        setIsSubmitting(true);
        
        try {
            if (
                values?.firstname !== "" && 
                values?.lastname !== "" && 
                values?.email !== "" && 
                values?.username !== " " && 
                values?.userrole !== " " && 
                values?.phone !== "" && 
                !changePassword
            ) {
                const phoneNumber = formatPhoneNumberIntl(values?.phone)
                let dialCodeWithPlus = phoneNumber.match(/^\+\d+(\s|$)/)[0];
                let restOfNumber = phoneNumber.slice(dialCodeWithPlus?.length);
                let mobileNumberWithoutSpaces = restOfNumber.replace(/\s/g, '');
                let dialCodeWithoutSpaces = dialCodeWithPlus.replace(/\s/g, '');
                
                const formattedValues = {
                    userName: values?.username,
                    role: values?.userrole?.value || values?.userrole,
                    email: values?.email,
                    "profile": {
                        firstName: values?.firstname,
                        lastName: values?.lastname,
                    },
                    phone: mobileNumberWithoutSpaces,
                    dialCode: dialCodeWithoutSpaces,
                    status: values?.status?.value || values?.status,
                    isSSOUser: values?.isSSOUser,
                    ...(values.isSSOUser && idps.includes("Keycloak") && { rbac: idps.find(idp => idp !== "Keycloak") }),
                    domain: domain || "",
                    ...(operatorUser && {operatorId: operatorId})
                };
    
                if (!isEdit) {
                    // Enhanced createUser dispatch with success callback
                    dispatch(createUser(
                        formattedValues, 
                        setLoading, 
                        (success) => {
                            setIsSubmitting(false);
                            if (success && onSuccess) {
                                onSuccess('create');
                            }
                        }, 
                        logoFile
                    ));
                } else if (isEdit && isStatus) {
                    setIsSubmitting(false);
                    toggleModal()
                } else {
                    // FIXED: Enhanced updateUser dispatch with success callback
                    dispatch(updateUser(
                        setLoading, 
                        formattedValues, 
                        navigate,
                        operatorUser ? userInformation?.userDetails?.userId :userId, 
                        false, // isProfile
                        false,
                        profile, 
                        update, 
                        setUpdate, 
                        fileSelected, 
                        logoFile, 
                        editData, 
                        setFileSelected,
                        // Add the success callback
                        (result) => {
                            setIsSubmitting(false);
                            if (result === 'update' && onSuccess) {
                                onSuccess('update');
                            } else if (result === 'error') {
                                // Handle error case if needed
                                console.error('Update failed');
                            }
                        }
                    ));
                }
            } else {
                setIsSubmitting(false);
            }
        } catch (error) {
            setIsSubmitting(false);
            console.error("Form submission error:", error);
        }
    };

    return (
        <React.Fragment>
            <div >
                <Formik
                    enableReinitialize={true} // This allows Formik to reinitialize when initialValues change
                    validationSchema={validationSchemaForUser(changePassword)}
                    initialValues={getInitialValues()}
                    onSubmit={handleFormSubmit}
                >
                    {({ handleChange, handleBlur, handleSubmit, errors, touched, values, setFieldValue, setFieldTouched, resetForm }) => (
                        <Form className='needs-validation' onSubmit={handleSubmit}>
                            <Container fluid>
                                <ToastContainer position='top-center' />
                                <Row>
                                    {loading && (<Loader />)}
                                    <Col lg={12}>
                                        <div className='listingjs-table mt-n4' id='userList'>

                                            <UserDetails 
                                                profileData={profileData} 
                                                documentName={documentName} 
                                                setUpdate={setUpdate} 
                                                setFileSelected={setFileSelected} 
                                                profile={profile} 
                                                imageOn={imageOn} 
                                                setImageOn={setImageOn} 
                                                logoFile={logoFile} 
                                                setLogoFile={setLogoFile} 
                                                values={values} 
                                                errors={errors} 
                                                touched={touched} 
                                                setFieldTouched={setFieldTouched} 
                                                setFieldValue={setFieldValue} 
                                                handleBlur={handleBlur} 
                                                handleChange={handleChange} 
                                                isEdit={isEdit} 
                                                user={user} 
                                                userId={operatorUser ? userInformation?.userDetails?.userId :userId} 
                                                navigate={navigate} 
                                                dispatch={dispatch} 
                                                setLoading={setLoading} 
                                                changePassword={changePassword} 
                                                modalOpen={modalOpen} 
                                                setModalOpen={setModalOpen} 
                                                toggleModal={toggleModal} 
                                                isStatus={isStatus} 
                                                setIsStatus={setIsStatus} 
                                                isUserPath={isUserPath}
                                                customRoles={customRoles}
                                                isGroupedOptions={isGroupedOptions}
                                                operatorUser={operatorUser ? operatorUser : false}
                                                operatorId={operatorId}
                                                onCancel={onCancel}
                                            />
                                            <Row lg={6} className=' justify-content-center mb-4'>
                                                <div className='live-preview'>
                                                    {!changePassword ?
                                                        <Row className="justify-content-end mb-2 mt-2">
                                                            <div className="live-preview">
                                                                <div className="d-flex justify-content-center gap-2 mt-2">
                                                                    <CommonButton
                                                                        outline={true}
                                                                        className={
                                                                            "btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"
                                                                        }
                                                                        color={"main-color"}
                                                                        type={"button"}
                                                                        buttonAction={() => {
                                                                            resetForm();
                                                                            handleCancel();
                                                                        }}
                                                                        buttonText={"Cancel"}
                                                                        disabled={isSubmitting}
                                                                        icon={
                                                                            <i className="ri-close-fill label-icon align-middle fs-16 me-1" style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}>
                                                                            </i>
                                                                        }
                                                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                                                    />

                                                                    <CommonButton
                                                                        color={"secondary"}
                                                                        type="submit"
                                                                        buttonText={isSubmitting ? "Submitting..." : "Submit"}
                                                                        disabled={isSubmitting}
                                                                        icon={<i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>}
                                                                        className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1  w-md-auto text-nowrap"
                                                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </Row>
                                                        : null}
                                                </div>
                                            </Row>
                                        </div>
                                    </Col>
                                </Row>
                            </Container>
                        </Form>
                    )}
                </Formik>
            </div>
        </React.Fragment>
    )
}